import { getAccountId } from "../requirements/SelectAccountScreen";

export const persistAuthTokenFromVerifyResponse = (payload) => {
  if (typeof window === "undefined" || !payload || typeof payload !== "object") {
    return;
  }
  const token =
    payload.token ||
    payload.authToken ||
    payload.accessToken ||
    payload.data?.token ||
    payload.data?.authToken ||
    payload.data?.accessToken;
  if (token) {
    window.localStorage.setItem("userToken", String(token));
  }
};

export const persistLoggedInUser = (user, token) => {
  if (typeof window === "undefined") return;
  if (token) {
    window.localStorage.setItem("userToken", String(token));
  }
  if (user) {
    window.localStorage.setItem("user", JSON.stringify(user));
    if (user.accountType) {
      window.localStorage.setItem("accountType", String(user.accountType));
    }
  }
};

export const extractLinkedAccounts = (payload) => {
  const candidates = [
    payload?.accounts,
    payload?.profiles,
    payload?.users,
    payload?.data?.accounts,
    payload?.data?.profiles,
    payload?.data?.users,
    payload?.data?.userDetails,
    payload?.result?.accounts,
    payload?.result?.profiles,
    payload?.result?.users,
  ];
  const accountList = candidates.find(Array.isArray) || [];
  if (accountList.length > 0) {
    return accountList.filter((account) => getAccountId(account));
  }

  const singleAccountCandidates = [
    payload?.account,
    payload?.profile,
    payload?.user,
    payload?.data?.account,
    payload?.data?.profile,
    payload?.data?.user,
    payload?.data?.userDetails,
    payload?.result?.account,
    payload?.result?.profile,
    payload?.result?.user,
  ];
  const singleAccount = singleAccountCandidates.find((account) => getAccountId(account));
  return singleAccount ? [singleAccount] : [];
};
